var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.name,{tag:"component",attrs:{"object":_vm.object,"color1":_vm.color1,"color2":_vm.color2,"size":_vm.size,"speed":_vm.speed,"bg":_vm.bg,"objectbg":_vm.objectbg,"opacity":_vm.opacity,"disableScrolling":_vm.disableScrolling}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }